/**
 * Root layout — sidebar + main area.
 * Matches shadcn-admin shell pattern.
 *
 * Header includes: global search + client selector.
 * unclaimedCount fed from real API (useLeadsList).
 */

import { Outlet } from '@tanstack/react-router'
import { Sidebar } from './Sidebar'
import { ClientSelector } from '@/components/ClientSelector'
import { Search } from 'lucide-react'
import { useLeadsList } from '@/hooks/useLeads'

export function AppLayout() {
  const { data: leads = [] } = useLeadsList('unclaimed')
  const unclaimedCount = leads.length

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <Sidebar unclaimedCount={unclaimedCount} />

      <div className="flex flex-col flex-1 overflow-hidden">
        {/* Top header bar */}
        <header className="flex h-14 items-center gap-4 border-b bg-card px-6 shrink-0">
          <div className="flex flex-1 items-center gap-2 rounded-md border bg-background px-3 py-1.5 text-sm text-muted-foreground max-w-sm">
            <Search className="h-4 w-4" />
            <input
              type="search"
              placeholder="Поиск по имени, телефону..."
              className="flex-1 bg-transparent outline-none placeholder:text-muted-foreground"
            />
          </div>

          {/* Client selector — right side of header */}
          <div className="ml-auto">
            <ClientSelector />
          </div>
        </header>

        {/* Page content */}
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
